import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function mod(n: number, m: number): number {
  return ((n % m) + m) % m;
}

export function padZero(n: number, digits = 2): string {
  return String(n).padStart(digits, "0");
}

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}